<template>

  <a-alert show-icon type="info" class="blue-alert">
    <template #icon>
      <InfoCircleFilled style="color: var(--main-blue)"/>
    </template>

    <template #message>
      <p>
        Для подробной аналитики запросите <span @click="showConsultModal" class="consult">консультацию специалиста</span>
      </p>
    </template>
  </a-alert>

  <pop-up-form title="Получить консультацию по продукту"
                 comment="Хочу получить консультацию по тесту"
                 v-if="openConsultModal"
                 @closeModal="openConsultModal = false" />
</template>

<script>
import PopUpForm from "../../../../components/Popups/PopUpForm.vue";
import {ref} from "vue";
import {InfoCircleFilled} from "@ant-design/icons-vue";

export default {
    name: "chart-consultation",
    components: {InfoCircleFilled, PopUpForm},
    setup() {
        const openConsultModal = ref(false)
        const showConsultModal = () => {
            openConsultModal.value = !openConsultModal.value
        }

        return {
            showConsultModal,
            openConsultModal
        }
    }
}
</script>

<style lang="scss" scoped>
  .blue-alert {
    padding: 5px 20px;
    margin: 10px 0;
    border: none;
    border-radius: 6px;
  }

  .consult {
    cursor: pointer;
    text-decoration: underline;
  }
</style>